import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "@/lib/api";
import PageHero from "@/components/PageHero";

const CATEGORIES = ["ALL", "EVENTS", "RUNNERS", "DESTINATIONS", "TRAILS", "CULTURE", "COMMUNITIES", "BEHIND THE SCENES"];

export default function GalleryPage() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("ALL");
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const visible = cat === "ALL" ? items : items.filter((g) => g.category === cat);

  return (
    <div data-testid="gallery-page">
      <PageHero eyebrow="GALLERY" title="Experience SPORTIVE."
        subtitle="Races, runners, destinations and the people who make them happen."
        image="https://images.unsplash.com/photo-1766970096331-78c8af007a3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxtYXJhdGhvbiUyMHJ1bm5lcnMlMjBmaW5pc2glMjBsaW5lJTIwdmljdG9yeSUyMGF0aGxldGV8ZW58MHx8fHwxNzg5MDY4MTIzfDA&ixlib=rb-4.1.0&q=85" />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div data-testid="gallery-filters" className="flex flex-wrap gap-2">
          {CATEGORIES.map((c) => (
            <button key={c} data-testid={`gallery-filter-${c.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setCat(c)}
              className={`rounded-full border px-4 py-1.5 font-mono text-[11px] tracking-[0.12em] transition-colors ${cat === c ? "border-brand-cyan bg-brand-cyan/15 text-brand-cyan" : "border-brand-line text-slate-400 hover:border-brand-cyan hover:text-brand-cyan"}`}>
              {c}
            </button>
          ))}
        </div>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {visible.map((g, i) => (
            <button key={g.id || i} data-testid={`gallery-item-${i}`} onClick={() => setLightbox(g)} className="group relative h-60 overflow-hidden rounded-2xl border border-brand-line text-left">
              <img src={g.url} alt={g.caption} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-brand-ink to-transparent p-4 opacity-0 transition-opacity group-hover:opacity-100">
                <p className="font-mono text-[10px] tracking-[0.2em] text-brand-olive">{g.category}</p>
                <p className="text-sm font-medium text-white">{g.caption}</p>
              </div>
            </button>
          ))}
        </div>
        {visible.length === 0 && <p className="mt-10 text-slate-500">No photos in this category yet.</p>}
      </section>

      {lightbox && (
        <div data-testid="gallery-lightbox" className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-brand-ink/90 backdrop-blur-sm" onClick={() => setLightbox(null)} />
          <div className="relative z-10 max-w-4xl">
            <button data-testid="lightbox-close" onClick={() => setLightbox(null)} className="absolute -right-2 -top-10 text-slate-300 hover:text-white"><X size={24} /></button>
            <img src={lightbox.url} alt={lightbox.caption} className="max-h-[75vh] w-full rounded-2xl border border-brand-line object-contain" />
            <p className="mt-3 text-center font-mono text-xs tracking-[0.2em] text-brand-olive">{lightbox.category} — {lightbox.caption}</p>
          </div>
        </div>
      )}
    </div>
  );
}
